import { BreathworkDifficultyLevel } from './Breathwork';
import { LocalizedString, localizedStringFromMap } from './LocalizedString';

export interface PublicBreathwork {
  id: string;
  position: number;
  name: LocalizedString;
  description: LocalizedString;
  goal: LocalizedString;
  activitiesIds: string[];
  benefitsIds: string[];
  difficultyLevel?: BreathworkDifficultyLevel;
  backgroundColor?: string;
}

export function publicBreathworkFromJson(json: Record<string, unknown>): PublicBreathwork {
  return {
    id: json['id'] as string,
    position: json['position'] as number,
    name: localizedStringFromMap(json['name'] as Record<string, unknown>),
    description: localizedStringFromMap(json['description'] as Record<string, unknown>),
    goal: localizedStringFromMap(json['goal'] as Record<string, unknown>),
    activitiesIds: (json['activities'] as string[] | undefined) ?? [],
    benefitsIds: (json['benefits'] as string[] | undefined) ?? [],
    difficultyLevel: json['difficultyLevel'] as BreathworkDifficultyLevel | undefined,
    backgroundColor: json['backgroundColor'] as string | undefined,
  };
}
